import React from 'react';
import CardProductGridImage from './CardProductGridImage';

interface BoxGallerySwiperImageFixedProps {
    product: any;
    category: any;
    loading: boolean;
    index: number;
    indexFixed?: number;
}

const BoxGallerySwiperImageFixed = ({
    product,
    category,
    loading,
    index,
    indexFixed
}: BoxGallerySwiperImageFixedProps) => {

    let extraClasses = '';

    if (indexFixed === 0 || (indexFixed && indexFixed % 3 === 0)) {
        extraClasses = 'aspect-[4/5]';
    } else if (indexFixed === 2) {
        extraClasses = 'aspect-[5/6]';
    } else {
        extraClasses = 'aspect-square';
    }

    return (
        <CardProductGridImage
            className={extraClasses}
            product={product}
            category={category}
            loading={loading}
            key={index}
        />
    );
};

export default BoxGallerySwiperImageFixed;
